
import { getConfig as getConfigFromProduction } from '../config/production';

// Re-export getConfig for use in other components
export const getConfig = getConfigFromProduction;

// API Configuration
export const API_URL_BASE = getConfig('API_URL') || 'https://api.jpro.app/api/v1';
const cleanUrl = API_URL_BASE.endsWith('/') ? API_URL_BASE.slice(0, -1) : API_URL_BASE;
export const API_URL = cleanUrl.endsWith('/api/v1') ? cleanUrl : `${cleanUrl}/api/v1`;


// Chat API Configuration (used by ChatModal)
export const PROJECT_ID = '42492';
export const API_KEY = getConfig('CHAT_API');

// Model Service Configuration
export const MODEL_SERVICE_URL = getConfig('MODEL_SERVICE_URL') || 'https://jpro-rag-py-g0d9hwabe5b8ctct.eastus2-01.azurewebsites.net';


// Chat Configuration
export const CHAT_MESSAGE_THRESHOLD = {
    STANDARD: 40,  // Maximum number of messages for standard chat
    ADVANCED: 60   // Maximum number of messages for advanced AI chat (lower due to complexity)
};

// Local Storage Keys — TOKEN was intentionally removed; the access token is now
// stored in memory only (see src/stores/authStore.js).
export const STORAGE_KEYS = {
    USER: 'jpro_user',
    CURRENT_CHAT_ID: 'jpro_current_chat_id',
    CURRENT_SESSION: 'jpro_current_session',
    CHAT_TYPE: 'jpro_chat_type'
};

// Session ID Prefixes
export const SESSION_PREFIXES = {
    STANDARD: 'jpro_chat_',
    ADVANCED: 'advanced_ai_'
};

// Feature Flags
export const FEATURES = {
    AUDIO_ENABLED: true,
    FILE_UPLOAD_ENABLED: true,
    SPEECH_TO_TEXT_ENABLED: true,
    IMAGE_GENERATION_ENABLED: true
};

// Default system messages
export const SYSTEM_MESSAGES = {
    STANDARD_WELCOME: "Welcome to your personal JPRO assistant. How can I help you with affordable housing topics today?",
    ADVANCED_WELCOME: "Welcome to Advanced AI Chat. I can help with text responses, analyze images, and work with uploaded documents. Ask me anything!",
    CONTINUE_STANDARD: "Welcome back to your conversation. How can I help you further with affordable housing topics?",
    CONTINUE_ADVANCED: "Welcome back to your Advanced AI Chat. Continue your conversation below!"
};

// File upload constraints
export const FILE_UPLOAD = {
    MAX_SIZE: 20 * 1024 * 1024, // 20MB
    ACCEPTED_TYPES: {
        DOCUMENTS: [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'text/plain'
        ],
        IMAGES: ['image/*'],
        AUDIO: ['audio/*'],
        VIDEOS: [
            'video/mp4',
            'video/mpeg',
            'video/mov',
            'video/avi',
            'video/x-flv',
            'video/mpg',
            'video/webm',
            'video/wmv',
            'video/3gpp'
        ]
    }
};